import { useState } from 'react';

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Todos', icon: 'ri-apps-line' },
    { id: 'normativas', name: 'Normativas', icon: 'ri-file-list-3-line' },
    { id: 'seguridad', name: 'Seguridad', icon: 'ri-shield-check-line' },
    { id: 'mantenimiento', name: 'Mantenimiento', icon: 'ri-tools-line' },
    { id: 'novedades', name: 'Novedades', icon: 'ri-lightbulb-line' }
  ];

  const articles = [
    {
      id: 1,
      title: 'Nueva Normativa CTE DB-SI 2023: Cambios en Protección contra Incendios',
      excerpt: 'Análisis detallado de las actualizaciones del Código Técnico de la Edificación en materia de seguridad contra incendios.',
      category: 'normativas',
      date: '15 Enero 2025',
      readTime: '8 min',
      image: 'https://public.readdy.ai/ai/img_res/347a4bf80c1ddaf8585bc029ab58395e.jpg',
      slug: 'nueva-normativa-cte-db-si-2023'
    },
    {
      id: 2,
      title: 'Gas Radón: Protocolo de Medición según RD 1029/2022',
      excerpt: 'Guía completa sobre los nuevos requisitos legales para la medición y control del gas radón en edificios.',
      category: 'normativas',
      date: '10 Enero 2025',
      readTime: '6 min',
      image: 'https://readdy.ai/api/search-image?query=radon%20gas%20measurement%20equipment%20in%20modern%20building%20interior%2C%20professional%20testing%20device%20with%20digital%20display%2C%20clean%20laboratory%20environment%20with%20white%20walls%2C%20technical%20precision%20instruments%2C%20scientific%20photography%20style&width=800&height=500&seq=blog2&orientation=landscape',
      slug: 'gas-radon-protocolo-medicion'
    },
    {
      id: 3,
      title: 'Sistemas de Detección Automática: Tecnologías Avanzadas 2025',
      excerpt: 'Comparativa de las últimas tecnologías en detección de incendios: detectores inteligentes, IoT y sistemas predictivos.',
      category: 'seguridad',
      date: '5 Enero 2025',
      readTime: '10 min',
      image: 'https://readdy.ai/api/search-image?query=advanced%20fire%20detection%20system%20with%20smart%20sensors%20on%20ceiling%2C%20modern%20IoT%20technology%20devices%2C%20futuristic%20white%20interior%20with%20blue%20LED%20indicators%2C%20high-tech%20security%20equipment%2C%20professional%20installation%20photography&width=800&height=500&seq=blog3&orientation=landscape',
      slug: 'sistemas-deteccion-automatica-2025'
    },
    {
      id: 4,
      title: 'Mantenimiento Preventivo de Extintores: Checklist Completo',
      excerpt: 'Lista de verificación profesional para el mantenimiento trimestral y anual de equipos de extinción.',
      category: 'mantenimiento',
      date: '28 Diciembre 2024',
      readTime: '5 min',
      image: 'https://readdy.ai/api/search-image?query=fire%20extinguisher%20maintenance%20inspection%20with%20professional%20technician%2C%20red%20extinguisher%20being%20checked%20with%20tools%20and%20clipboard%2C%20clean%20industrial%20setting%20with%20white%20background%2C%20safety%20equipment%20close-up%2C%20technical%20service%20photography&width=800&height=500&seq=blog4&orientation=landscape',
      slug: 'mantenimiento-preventivo-extintores'
    },
    {
      id: 5,
      title: 'BIM en Proyectos de Protección contra Incendios',
      excerpt: 'Cómo la metodología BIM está revolucionando el diseño e instalación de sistemas de protección contra incendios.',
      category: 'novedades',
      date: '20 Diciembre 2024',
      readTime: '7 min',
      image: 'https://readdy.ai/api/search-image?query=BIM%203D%20model%20of%20building%20fire%20protection%20systems%20on%20computer%20screen%2C%20digital%20blueprint%20with%20fire%20safety%20elements%20highlighted%20in%20red%2C%20modern%20office%20workspace%20with%20white%20desk%2C%20architectural%20software%20interface%2C%20professional%20engineering%20visualization&width=800&height=500&seq=blog5&orientation=landscape',
      slug: 'bim-proyectos-proteccion-incendios'
    },
    {
      id: 6,
      title: 'Formación Obligatoria en Seguridad Industrial 2025',
      excerpt: 'Requisitos actualizados de formación para trabajadores en instalaciones industriales según nueva legislación.',
      category: 'normativas',
      date: '15 Diciembre 2024',
      readTime: '6 min',
      image: 'https://readdy.ai/api/search-image?query=industrial%20safety%20training%20classroom%20with%20workers%20wearing%20helmets%2C%20professional%20instructor%20teaching%20fire%20safety%20procedures%2C%20modern%20training%20facility%20with%20white%20walls%20and%20safety%20posters%2C%20educational%20environment%2C%20corporate%20training%20photography&width=800&height=500&seq=blog6&orientation=landscape',
      slug: 'formacion-obligatoria-seguridad-industrial'
    }
  ];

  const filteredArticles = selectedCategory === 'all' 
    ? articles 
    : articles.filter(article => article.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/594dc4849304cbd3bd7a23edd8bf4d32/085c019ea1217b73a4a5e1e39cd86a89.jpeg"
                alt="PROTECPLUS INGENIERÍA"
                className="h-16 w-auto"
              />
            </a>
            <a 
              href="/"
              className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
            >
              <i className="ri-home-line mr-2"></i>
              Volver al Inicio
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-emerald-600 to-teal-700 text-white py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-2xl mb-6">
              <i className="ri-article-line text-4xl"></i>
            </div>
            <h1 className="text-5xl font-bold mb-4">Blog Técnico</h1>
            <p className="text-xl text-emerald-50">
              Artículos especializados sobre normativas, seguridad industrial y las últimas novedades del sector.
            </p>
          </div>
        </div>
      </div>

      {/* Categories Filter */}
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-wrap gap-3 justify-center">
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap ${
                selectedCategory === category.id
                  ? 'bg-gradient-to-r from-emerald-500 to-teal-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md'
              }`}
            >
              <i className={`${category.icon} text-lg`}></i>
              <span>{category.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Articles Grid */}
      <div className="container mx-auto px-6 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredArticles.map(article => (
            <article key={article.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all group">
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={article.image} 
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-white/90 backdrop-blur-sm text-emerald-600 px-3 py-1 rounded-full text-sm font-medium">
                    {categories.find(c => c.id === article.category)?.name}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center space-x-4 text-sm text-gray-500 mb-3">
                  <span className="flex items-center space-x-1">
                    <i className="ri-calendar-line"></i>
                    <span>{article.date}</span>
                  </span>
                  <span className="flex items-center space-x-1">
                    <i className="ri-time-line"></i>
                    <span>{article.readTime}</span>
                  </span>
                </div>
                
                <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-emerald-600 transition-colors">
                  {article.title}
                </h2>
                
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {article.excerpt}
                </p>
                
                <a 
                  href={`/blog/${article.slug}`}
                  className="inline-flex items-center space-x-2 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors whitespace-nowrap"
                >
                  <span>Leer más</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        {filteredArticles.length === 0 && (
          <div className="text-center py-16">
            <i className="ri-file-search-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-xl text-gray-500">No hay artículos en esta categoría</p>
          </div>
        )}
      </div>
    </div>
  );
}